import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { catchError, EMPTY, Observable } from 'rxjs';
import { LanguageCountryDictionary, LanguageDictionary } from '@nx-customer-apps/shared/utils';
import { AuthStore } from '../../../state/auth/auth.store';
import { SettingsStore } from '../../../state/settings/settings.store';
import { CountryLangugePair } from '@nx-customer-apps/shared/interfaces';
import { SnackbarService } from '@nx-customer-apps/shared/services';
import { RollOutPolicy } from '../../../policies';
import { MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe, UpperCasePipe } from '@angular/common';
import { SharedUiModule } from '@nx-customer-apps/shared/ui';

@Component({
    selector: 'vp-country-language-switcher',
    templateUrl: './country-language-switcher.component.html',
    styleUrls: ['./country-language-switcher.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButton, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, AsyncPipe, UpperCasePipe, TranslatePipe, SharedUiModule]
})
export class CountryLanguageSwitcherComponent implements OnInit {
    public settingsStore = inject(SettingsStore);
    public authStore = inject(AuthStore);
    private snackbarService = inject(SnackbarService);
    private rollOutPolicy = inject(RollOutPolicy);
    private translateSerivice = inject(TranslateService);

    public chevronIcon: 'expand_more' | 'expand_less' = 'expand_more';
    public languageCountryType = LanguageCountryDictionary;
    public languageType = LanguageDictionary;
    public countryLanguagePairs$: Observable<CountryLangugePair[]>;

    ngOnInit() {
        this.countryLanguagePairs$ = this.rollOutPolicy.getCountryLanguagePairs$().pipe(
            catchError(() => {
                const message = this.translateSerivice.instant('COMMON.ERRORS.LANGUAGE_SWITCHER');
                this.snackbarService.showInfo(message);
                return EMPTY;
            })
        );
    }
}
